<template>
  <div class="cloud">
    <img src="../assets/images/in/0706-中层云-01.png" alt="" />
    <img src="../assets/images/in/0706-底层云-07.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "Cloud"
};
</script>

<style scoped>
.cloud {
  width: 100%;
  position: absolute;
  top: 4rem;
}
img {
  width: 100%;
  position: absolute;
  -webkit-animation: cloud_moving 80s linear infinite alternate;
  animation: cloud_moving 80s linear infinite alternate;
}
img:nth-child(2) {
  -webkit-animation: cloud_moving 120s linear infinite alternate;
  animation: cloud_moving 120s linear infinite alternate;
  top: -20px;
}

@-webkit-keyframes cloud_moving {
  from {
    left: 0;
  }
  to {
    left: -100%;
  }
}

@keyframes cloud_moving {
  from {
    left: 0;
  }
  to {
    left: -100%;
  }
}
</style>
